export enum DigitalResourcesOrderingEnum {
  Name = 'Name',
  Created = 'Created',
}
